const shuffle = <T>(items: T[]) => items.sort(() => Math.random() - 0.5)

export default shuffle
